import { useCallback, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { MoreIcon } from '../../../components/Icon';
import { BED_STATUS_CUBICLE_COLOR } from '../../../comm/constant';
import EditNurseStation from './Popups/EditNurseStation';

const useStyles = makeStyles(() => ({
  root: ({ data }) => ({
    backgroundColor: BED_STATUS_CUBICLE_COLOR[data?.color] ?? '#fff',
  }),
  name: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: '#7d86a9',
    fontSize: '1.25rem',
    width: '80%',
    textAlign: 'center',
  },
  moreBtn: {
    width: '2rem',
    height: '2rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '4px',
  },
  moreIcon: {
    fontSize: '1rem',
    color: '#7d86a9',
  },
}));

const NurseStation = ({
  style,
  width,
  height,
  handleUpdateNurseStation,
  edit,
  handleDeleteCubicle,
  setPopup,
  handleCopyCubicle,
  readOnly = false,
  checkLogin = () => {},
  ...data
}) => {
  const classes = useStyles({ data });
  const [editPopup, setEditPopup] = useState(false);
  const { isCubicleV2 } = useSelector((state) => state.bedStatusView);

  const handleOpenMore = useCallback(
    (event) => {
      !readOnly && checkLogin() && setEditPopup(true);
    },
    [readOnly, checkLogin]
  );

  const handleEditPopup = useCallback(
    (open) => () => {
      setEditPopup(open);
    },
    []
  );

  return (
    <>
      <Box
        className={classes.root}
        style={style}
        position="relative"
        display="inline-flex"
        minWidth={isCubicleV2 ? '9.786rem' : '11rem'}
        minHeight={isCubicleV2 ? '7.336rem' : '9.3rem'}
        border={data.borderLine === 'show' ? 'solid 1px #AAAAAA' : 'unset'}
        borderRadius="8px"
        p={isCubicleV2 ? '0.357rem' : '0.875rem 0.813rem 0.875rem 0.688rem'}
      >
        <Box position="absolute" right="0.75rem">
          <ButtonBase className={classes.moreBtn} onClick={handleOpenMore}>
            <MoreIcon className={classes.moreIcon} />
          </ButtonBase>
        </Box>
        <div className={classes.name}>{data.name}</div>
        {/* 撑开size */}
        <Box display="flex" flexDirection="column">
          <Box height="4.5rem" width="100%" />
          <Box
            display="grid"
            gridTemplateRows={`repeat(${data.bedArrangement.row}, 1fr)`}
            gridTemplateColumns={`repeat(${data.bedArrangement.column}, 1fr)`}
            gridGap="0.2rem"
          >
            {data.beds.map((item) => (
              <Box
                key={item.key}
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="5rem"
                height="4.688rem"
                pt="1.563rem"
              />
            ))}
          </Box>
        </Box>
      </Box>
      {editPopup && (
        <EditNurseStation
          handleClose={handleEditPopup(false)}
          data={data}
          handleUpdateNurseStation={handleUpdateNurseStation}
          edit={edit}
          handleDeleteCubicle={handleDeleteCubicle}
          setPopup={setPopup}
          handleCopyCubicle={handleCopyCubicle}
        />
      )}
    </>
  );
};

export default NurseStation;
